export default __webpack_public_path__ + "static/media/icon-location.aa39749a.svg";